import apiConfig from "../../apiConfig";

export const getDonationSidesList = async (at) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Sides/Get_Donations_Sides_List",
		{},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response;
};
